/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { slugify } from '@helpers/url';

export const getRemoveFacetsList = flatFacetsData =>
  flatFacetsData.facets
    .filter(facet => facet.widgetName === 'RemoveFacets')
    .reduce((prevVal, item) => {
      const { facets: facetItems } = item;
      return prevVal.concat(facetItems);
    }, []);

export const getItemFacetCount = (algoliaFacets?: any, removeFacetsList?: any) =>
  algoliaFacets
    .filter(facet => !facet.name.startsWith('extra.') && !removeFacetsList.includes(facet.name))
    .reduce((prevVal, item) => {
      const { data, name } = item;
      const productCount = Object.values(data).reduce(
        (total: number, value: number) => total + value,
        0
      );
      prevVal.push({ name, count: productCount });
      return prevVal;
    }, []);

export const parseFacetName = (facetName: string) => {
  if (!facetName || Array.isArray(facetName)) {
    return '';
  }
  return facetName.replace('product_hub.attributes.', '').replace('preco_promocional', 'Preço');
};

export const applyVisualFilter = (item, visualFilters) => {
  if (item.widgetName === 'RefinementList' && visualFilters[item.attribute]) {
    return { ...item, visualFilter: visualFilters[item.attribute] };
  }
  return { ...item, visualFilter: null };
};

export const facetsNames = item => {
  const { attribute, widgetName, section, priority } = item;

  const facetName = attribute || widgetName;

  const filters = {
    RangeInput: slugify(`filter-${facetName}`),
    HierarchicalMenu: slugify('filter-Categoria'),
    RatingMenu: slugify('filter-Avaliações'),
    SectionToggle: slugify(`toggle-${section}-${priority}`),
    RefinementList: slugify(`filter-${facetName}`),
  };

  return filters[widgetName];
};
